function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React from 'react';
import { Svg, Path } from "react-native-svg-web";



export const ArrowRightIcon = ({
  className,
  size = 24,
  color,
  ...restProps }) => /*#__PURE__*/

React.createElement(Svg, _extends({},

restProps, {
  className: className,
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }), /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929L12.5858 12L9.29289 8.70711C8.90237 8.31658 8.90237 7.68342 9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L15.4142 12L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071Z",
  fill: color }));